export default __webpack_public_path__ + "static/media/RPLogotagline-High-Res.25dfd557.png";